module.exports = __webpack_public_path__ + "img/banner.37b37a36.jpg";